import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";

import { ReactComponent as EyeSvg } from "../../../assets/icons/eye.svg";
import { ReactComponent as EditSvg } from "../../../assets/profile/edit.svg";
import { ReactComponent as DeleteSvg } from "../../../assets/profile/delete.svg";
import { ReactComponent as WarningSvg } from "../../../assets/icons/warning.svg";

import Modal from "./Modal";
import ProfileContext from "../ProfileContext";
import AppContext from "../../../AppContext";
import { langComponent } from "../../../constants";
import useCertificates from "../../../hooks/useCertificates";
import Overlay from "../../Overlay";
import Button from "../../common/Button";
import { toast } from "react-toastify";

const ItemList = ({ item, onModalSuccess }) => {
  const [isToggleModal, setIsToggleModal] = useState(false);
  const { isOwner, isCompany, viewMode } = useContext(ProfileContext);
  const { user, isAllowed, getLang } = useContext(AppContext);
  const TranslationCommon = getLang(langComponent.common);
  const [modalMode, setModalMode] = useState(undefined);
  const [isToggleDelete, setIsToggleDelete] = useState(false);
  const { deleteCertificate } = useCertificates();

  const handleViewClick = () => {
    setIsToggleModal(true);
    setModalMode("view");
  };

  const handleEditClick = () => {
    setIsToggleModal(true);
    setModalMode("edit");
  };

  const handleDeleteClick = () => {
    setIsToggleDelete(true);
  };

  const handleModalClose = () => {
    setIsToggleModal(false);
    setModalMode(undefined);
  };

  const handleModalSuccess = () => {
    setIsToggleModal(false);
    setModalMode(undefined);
    onModalSuccess();
  };

  const getStatus = (statusCert) => {
    if (statusCert === 1) {
      return TranslationCommon("Pending");
    }

    if (statusCert === 2) {
      return TranslationCommon("Approved");
    }

    return TranslationCommon("Rejected");
  };

  const getCertEditAction = () => {
    if (viewMode === "guest") return <></>;

    if (!isCompany && isOwner)
      return (
        <EditSvg
          className="profile-card-certs-lists-item__cta__edit"
          onClick={handleEditClick}
        />
      );

    if (isCompany && isAllowed("CM-04-0000", "update"))
      return (
        <EditSvg
          className="profile-card-certs-lists-item__cta__edit"
          onClick={handleEditClick}
        />
      );

    return <></>;
  };

  const getCertDeleteAction = () => {
    if (viewMode === "guest") return <></>;

    if (!isCompany && isOwner)
      return (
        <DeleteSvg
          className="profile-card-certs-lists-item__cta__delete"
          onClick={handleDeleteClick}
        />
      );

    if (isCompany && isAllowed("CM-04-0000", "delete"))
      return (
        <DeleteSvg
          className="profile-card-certs-lists-item__cta__delete"
          onClick={handleDeleteClick}
        />
      );

    return <></>;
  };

  const handleDelete = () => {};

  const _getModalDelete = () => {
    // * Get work from datasource
    const prefix = "profile-card-certs-lists-item";

    return (
      <Overlay
        onClose={() => {
          setIsToggleDelete(false);
        }}
        style={{
          alignItems: "flex-start",
        }}
      >
        <div className={`${prefix}-delete`}>
          <WarningSvg width={64} />
          <p className={`${prefix}-delete__header`}>
            {TranslationCommon(`Delete ${item.name}?`)}
          </p>
          <div className={`${prefix}-delete__action`}>
            <Button
              variant={"secondary"}
              label={"Cancel"}
              onClick={() => setIsToggleDelete(false)}
            />
            <Button
              label={"Confirm"}
              onClick={() => {
                deleteCertificate(item._id)
                  .then(() => {
                    onModalSuccess();
                  })
                  .catch((err) => {
                    toast.error("Unable to delete certificate");
                  });
              }}
            />
          </div>
        </div>
      </Overlay>
    );
  };

  const { _id, name, issuer, period, status } = item;

  return (
    <>
      <div className="profile-card-certs-lists-item">
        {isOwner && (
          <div
            className={`profile-card-certs-lists-item__status profile-card-certs-lists-item__status--${status}`}
          >
            {getStatus(status)}
          </div>
        )}
        <div className="profile-card-certs-lists-item__title">{name}</div>
        <div className="profile-card-certs-lists-item__cta">
          <EyeSvg
            className="profile-card-certs-lists-item__cta__look"
            onClick={handleViewClick}
          />
          {getCertEditAction()}
          {getCertDeleteAction()}
        </div>
        <div className="profile-card-certs-lists-item__desc">{issuer}</div>
        <div className="profile-card-certs-lists-item__issued-period">
          {period}
        </div>
      </div>
      {isToggleModal && modalMode && (
        <Modal
          id={_id}
          mode={modalMode}
          onClose={handleModalClose}
          onSuccess={handleModalSuccess}
        />
      )}
      {isToggleDelete && _getModalDelete()}
    </>
  );
};

ItemList.propTypes = {
  id: PropTypes.string.isRequired,
};

export default ItemList;
